import { types } from 'mobx-state-tree'

export const WebhooksBaseModel = types.model('WebhooksModel').props({
  __typename: types.optional(types.literal('Webhooks'), 'Webhooks'),
  user_passed_quiz: types.string,
  user_failed_quiz: types.string,
  user_completed_assignment: types.string,
})
